module.exports = __webpack_public_path__ + "img/cornelius-van-drebel.1cf62c38.png";